import React, { useEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoutes from "./private.routes";
import { getOrCreateContactUuid } from '../utils/contactUuid';
import { SessionManager } from '../session/SessionManager';

const uuid = getOrCreateContactUuid();

const MainRoutes = (props) => {
	const { botId } = props;
	const initializedRef = useRef(false);

	// Initialize SessionManager with uuid and botId
	useEffect(() => {
		if (botId && !initializedRef.current) {
			SessionManager.initialize(uuid, botId);
			initializedRef.current = true;
		}
	}, [botId]);

	const mergedProps = { ...props, uuid };

	return (
		<Routes>
			<Route
				path="/private/*"
				element={
					<PrivateRoutes {...mergedProps}/>
				}
			/>
		</Routes>
	);
};
export default MainRoutes;